import AiAgentAsCs from '../../../../components/units/Management/AiAgent/AsCs/List';

export default function AiAgentAsCsPage() {
  return <AiAgentAsCs />;
}
